export function ProgressRing({ pct = 0, size = 44, stroke = 4, className = "", children, testid }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const p = Math.max(0, Math.min(100, pct));
  return (
    <div className={`relative inline-flex shrink-0 items-center justify-center ${className}`} style={{ width: size, height: size }} data-testid={testid} data-pct={p}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="currentColor" strokeWidth={stroke} className="text-muted" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * p) / 100} className={`transition-[stroke-dashoffset] duration-700 ${p >= 100 ? "text-sage" : "text-primary"}`} />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center text-[11px] font-semibold">{children ?? `${p}%`}</span>
    </div>
  );
}
